import { jsx as i, jsxs as D } from "react/jsx-runtime";
import * as p from "react";
import { cn as w } from "../../../lib/utils.js";
const S = p.forwardRef(({ length: s = 6, value: n = "", onChange: e, onComplete: f, label: y, error: b, helperText: x, disabled: N = !1, className: v, size: j = "md", showSeparator: O = !1, type: k = "number" }, A) => {
  const [m, d] = p.useState(n.split("").concat(Array(s).fill("")).slice(0, s)), u = p.useRef([]);
  p.useEffect(() => {
    d(n.split("").concat(Array(s).fill("")).slice(0, s));
  }, [n, s]);
  const R = (t, r) => {
    var a;
    const c = r.slice(-1);
    if (c && !/^\d$/.test(c))
      return;
    const o = [...m];
    o[t] = c, d(o);
    const l = o.join("");
    e == null || e(l), c && t < s - 1 && ((a = u.current[t + 1]) == null || a.focus()), l.length === s && !l.includes("") && (f == null || f(l));
  }, P = (t, r) => {
    var c, o, l;
    if (r.key === "Backspace") {
      r.preventDefault();
      const a = [...m];
      m[t] ? (a[t] = "", d(a), e == null || e(a.join(""))) : t > 0 && (a[t - 1] = "", d(a), e == null || e(a.join("")), (c = u.current[t - 1]) == null || c.focus());
    }
    r.key === "ArrowLeft" && t > 0 && ((o = u.current[t - 1]) == null || o.focus()), r.key === "ArrowRight" && t < s - 1 && ((l = u.current[t + 1]) == null || l.focus());
  }, F = (t) => {
    var l;
    t.preventDefault();
    const r = t.clipboardData.getData("text/plain").replace(/\D/g, "").slice(0, s), c = r.split("").concat(Array(s).fill("")).slice(0, s);
    d(c), e == null || e(r);
    const o = Math.min(r.length, s - 1);
    (l = u.current[o]) == null || l.focus(), r.length === s && (f == null || f(r));
  }, I = (t) => {
    var r;
    (r = u.current[t]) == null || r.select();
  }, M = () => {
    switch (j) {
      case "sm":
        return "w-8 h-10 text-base";
      case "lg":
        return "w-12 h-14 sm:w-14 sm:h-16 text-xl sm:text-2xl";
      default:
        return "w-10 h-12 sm:w-12 sm:h-14 text-lg sm:text-xl";
    }
  };
  return i("div", { ref: A, className: w("w-full bg-bg-surface border border-border-color rounded-2xl shadow-card p-6", v), children: D("div", { className: "space-y-3", children: [y && i("label", { className: "block text-sm font-medium text-text-primary", children: y }), i("div", { className: "flex items-center justify-center gap-2 sm:gap-3", children: m.map((t, r) => D(p.Fragment, { children: [i("input", { ref: (c) => u.current[r] = c, type: "text", inputMode: "numeric", maxLength: 1, value: t, onChange: (c) => R(r, c.target.value), onKeyDown: (c) => P(r, c), onPaste: F, onFocus: () => I(r), disabled: N, className: w("text-center font-bold rounded-lg border-2 bg-bg-surface", "transition-all duration-300 ease-luxury", "hover:border-lpr-gold/60", "focus:outline-none focus:ring-lpr-gold focus:ring-lpr-gold/50 focus:ring-offset-1 focus:shadow-glow focus:border-lpr-gold", "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-bg-muted", M(), b ? "border-lpr-red focus:ring-lpr-red/50" : t ? "border-lpr-gold" : "border-border-color") }), O && r === Math.ceil(s / 2) - 1 && r < s - 1 && i("div", { className: "w-2 h-1 bg-border-color rounded-full mx-1" })] }, r)) }), (b || x) && i("p", { className: w("text-xs text-center", b ? "text-lpr-red" : "text-text-secondary"), children: b || x })] }) });
});
S.displayName = "OTPInput";
export {
  S as OTPInput
};
//# sourceMappingURL=OTPInput.js.map
